import { render, staticRenderFns } from "./MainDefaultTemplate.vue?vue&type=template&id=814bd5b2&"
import script from "./MainDefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./MainDefaultTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports